import { SxProps } from '@mui/material'
import { alpha } from '@mui/material/styles'

import theme from '../../../../../../shared/styles/themes/default.theme'
import { LockerBoxStatus } from './LockerBox.types'

const styles = {
  statusPalette: {
    available: {
      base: theme.palette.success.main,
      background: alpha(theme.palette.success.main, 0.12),
      dot: theme.palette.success.main
    },
    reserved: {
      base: theme.palette.info.main,
      background: alpha(theme.palette.info.main, 0.12),
      dot: theme.palette.info.main
    },
    occupied: {
      base: theme.palette.primary.main,
      background: alpha(theme.palette.primary.main, 0.12),
      dot: theme.palette.primary.main
    },
    overdue: {
      base: theme.palette.warning.main,
      background: alpha(theme.palette.warning.main, 0.2),
      dot: theme.palette.warning.dark
    }
  },

  getCardStyles: (status: LockerBoxStatus, isClickable: boolean): SxProps => {
    const palette = styles.statusPalette[status] ?? styles.statusPalette.available

    return {
      cursor: isClickable ? 'pointer' : 'default',
      borderRadius: theme.spacing(3),
      border: `1px solid ${alpha(palette.base, 0.4)}`,
      backgroundColor: palette.background,
      minHeight: 180,
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      boxShadow: '0px 18px 35px rgba(15, 23, 42, 0.14)',
      '&:hover': isClickable
        ? {
            transform: 'translateY(-4px)',
            boxShadow: '0px 24px 45px rgba(15, 23, 42, 0.2)'
          }
        : undefined
    }
  },

  bodyContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  bodyContentText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.5)
  },

  arrowIcon: {
    color: theme.palette.text.primary,
    fontSize: '16px'
  },

  loadingIndicator: {
    color: theme.palette.primary.main
  },

  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5)
  },

  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  // Locker number over the SmartLocker door ID, both left-aligned
  lockerName: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },

  statusGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },

  statusChip: (status: LockerBoxStatus): SxProps => {
    const palette = styles.statusPalette[status] ?? styles.statusPalette.available

    return {
      textTransform: 'capitalize',
      backgroundColor: palette.dot,
      color: theme.palette.common.white,
      '& .MuiChip-label': {
        px: 1
      }
    }
  },

  assignmentText: (isAssigned: boolean): SxProps => ({
    fontWeight: isAssigned ? 600 : 400,
    color: isAssigned ? theme.palette.text.primary : theme.palette.text.secondary
  }),

  emptyStateBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}

export default styles
